import Swiper from "swiper/bundle";

/**
 * crafto/demo-recruitment.html — due strisce; la seconda con autoplay inversa
 */
function initMarqueeText(root = document) {
    const swipers = root.querySelectorAll(".block-marquee-text__swiper");

    swipers.forEach((el) => {
        if (el.swiper) {
            el.swiper.destroy(true, true);
        }

        if (!el.querySelector(".swiper-slide")) {
            return;
        }

        const reverse =
            el.closest(".marquee-rotate-up") !== null;

        /** @type {import("swiper").SwiperOptions} */
        const options = {
            slidesPerView: "auto",
            slidesOffsetBefore: 16,
            spaceBetween: 60,
            centeredSlides: true,
            speed: 20000,
            loop: true,
            effect: "slide",
            allowTouchMove: false,
            watchOverflow: true,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
                reverseDirection: reverse,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        };

        new Swiper(el, options);
    });
}

export { initMarqueeText };
